import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'login',
			component: Login,
		},
		{
			path: '/work-start',
			name: 'work-start',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/WorkStart.vue')
		},
		{
			path: '/work-end',
			name: 'work-end',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/WorkEnd.vue')
		},
		{
			path: '/app-base',
			name: 'app-base',
			component: () => import('./views/AppBase.vue'),
			children: [
				{
					path: '/dashboard',
					name: 'dashboard',
					component: () => import('./views/Dashboard.vue'),
					meta: { requireAuth: true },
				},
				{
					path: '/time-card',
					name: 'time-card',
					component: () => import('./views/TimeCard.vue'),
					meta: { requireAuth: true },
				},
			],
		},
	]
})

router.beforeEach((to, from, next) => {
	//console.log(to);
	let isNext = false;
	if (to.matched.some(record => record.meta.requireAuth)) {
		// 認証トークン存在チェック
		if (!store.state.auth || !store.state.auth.token) {
			//console.log('login');
			next({ path: '/' });
		}
	}

	//console.log('next2');
	next();
})

export default router;
